import "@/styles/components/page-header.css";

const setupPageHeaderAnimatedList = () => {
  const animatedList = document.querySelector("[data-page-header-animated-list]");

  if (!animatedList) {
    return;
  }

  const listItems = animatedList.querySelectorAll("li");

  if (!listItems.length) {
    return;
  }

  const asGrid = animatedList.dataset.pageHeaderAnimatedList === "grid";
  let isPaused = false;
  let currentIndex = 0;
  let indexMapping = [];

  if (asGrid) {
    const itemsPerColumn = Math.ceil(listItems.length / 2);

    indexMapping = Array(listItems.length)
      .fill(0)
      .map((_, i) => {
        const column = Math.floor(i / itemsPerColumn);
        const row = i % itemsPerColumn;
        return row * 2 + column;
      });
  }

  const links = animatedList.querySelectorAll("a, button");

  links.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      isPaused = true;
    });

    link.addEventListener("mouseleave", () => {
      isPaused = false;
    });
  });

  setInterval(() => {
    if (isPaused) {
      return;
    }

    listItems[currentIndex].classList.remove("is-active");

    if (asGrid) {
      const mappingIndex = indexMapping.findIndex((idx) => idx === currentIndex);
      const nextMappingIndex = (mappingIndex + 1) % indexMapping.length;
      currentIndex = indexMapping[nextMappingIndex];
    } else {
      currentIndex = (currentIndex + 1) % listItems.length;
    }

    listItems[currentIndex].classList.add("is-active");
  }, 2000);
};

export default {
  init: () => {
    setupPageHeaderAnimatedList();
  },
};
